export default "__VITE_ASSET__c1bd3f95__"